import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import API_ENDPOINTS from '../../helperFunction/Constant';
import ApiHelper from '../../helperFunction/ApiHelper';
import { Toast } from 'primereact/toast';
import Layout from '../common/Layout';
import { useForm } from 'react-hook-form';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'

const AddNotifications = () => {

    const { id } = useParams()
    const isEdit = id ? true : false
    const toast = useRef(null)
    const navigate = useNavigate()

    const [notificationData, setNotificationData] = useState([])

    useEffect(() => {
        isEdit && getNotificationData()
    }, [])

    const schema = yup.object({
        title: yup.string().required("Title is required"),
        body: yup.string().required("Body is required"),
        imageUrl: yup.mixed().test("icon-required", "Image is required", function (value) { return ((value && value.length > 0) || notificationData?.imageUrl); }),
        type: yup.string().required("Type is required"),
        referenceId: yup.string().required("Reference ID is required"),
        deepLink: yup.string().required("Deep Link is required"),
        actionText: yup.string().required("Action Text is required"),
        isRead: yup.boolean(),
    });

    const { register, handleSubmit, reset, watch, resetField, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });

    const resetValue = () => {
        reset({
            title: '',
            body: '',
            imageUrl: null,
            type: '',
            referenceId: '',
            deepLink: '',
            actionText: '',
            isRead: false,
        })
    }

    const previewImage = watch('imageUrl')

    const getNotificationData = () => {
        ApiHelper.get(`${API_ENDPOINTS.NOTIFICATIONS}/${id}`).then((res) => {
            if (res.status === 200) {
                setNotificationData(res.data.data)
                reset({
                    title: res.data.data.title,
                    body: res.data.data.body,
                    imageUrl: res.data.data.imageUrl,
                    type: res.data.data.type,
                    referenceId: res.data.data.referenceId,
                    deepLink: res.data.data.deepLink,
                    actionText: res.data.data.actionText,
                    isRead: res.data.data.isRead,
                })
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const onSubmit = (data) => {
        const formData = new FormData()
        for (const [key, value] of Object.entries(data)) {
            formData.append(key, value);
        };
        if (data.imageUrl) {
            formData.append('imageUrl', data.imageUrl[0]);
        }
        formData.append('userId', 0);
        if (isEdit) {
            update(formData)
        } else {
            add(formData)
        }
    };
    const add = (data) => {
        ApiHelper.post(`${API_ENDPOINTS.NOTIFICATIONS}/`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/notifications')
                }, 900)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };
    const update = (data) => {
        ApiHelper.put(`${API_ENDPOINTS.NOTIFICATIONS}/${id}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/notifications')
                }, 900)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const confirmDeleteDailog = () => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: null,
            acceptClassName: 'p-button-danger',
            accept: () => deleteImage(),
        });
    };

    const deleteImage = () => {
        ApiHelper.post(`${API_ENDPOINTS.NOTIFICATIONS}/delete-image/${id}`).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 });
                getNotificationData()
            }
        }).catch((err) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: err.response?.data?.message, life: 3000 });
        });
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3 mb-2">
                                <span class="d-flex text-muted fw-light"> 
                                    <p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate('/notifications')}> Notifications </p> / <b className='mx-2'> {isEdit ? 'Edit' : "Add"} </b>
                                </span>
                            </h4>
                            <Link to="/notifications" class="btn btn-secondary">⬅ Go Back</Link>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div class="row mb-3">
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Title</label>
                                                    <input type="text" name="title" class="form-control" {...register("title")} />
                                                    <small className="text-danger">{errors.title?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Body</label>
                                                    <input type="text" name="body" class="form-control" {...register("body")} />
                                                    <small className="text-danger">{errors.body?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Type</label>
                                                    <select id="mySelect" name="type" class="form-select" {...register("type")} >
                                                        <option value="">Select Type</option>
                                                        <option value='order'>Order</option>
                                                        <option value='course'>Course</option>
                                                        <option value='quiz'>Quiz</option>
                                                        <option value='reminder'>Reminder</option>
                                                    </select>
                                                    <small className="text-danger">{errors.type?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">reference ID</label>
                                                    <input type="text" name="referenceId" class="form-control" {...register("referenceId")} />
                                                    <small className="text-danger">{errors.referenceId?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Deep Link</label>
                                                    <input type="text" name="deepLink" class="form-control" {...register("deepLink")} />
                                                    <small className="text-danger">{errors.deepLink?.message}</small>
                                                </div>
                                                <div class="col-md-3 mb-3">
                                                    <label class="form-label">Action Text</label>
                                                    <input type="text" name="actionText" class="form-control" {...register("actionText")} />
                                                    <small className="text-danger">{errors.actionText?.message}</small>
                                                </div>
                                                {notificationData?.imageUrl ? (
                                                    <div class="col-md-3 mb-3">
                                                        <label class="form-label">Image Url</label>
                                                        <br />
                                                        <div>
                                                            <div class="d-inline-block ">
                                                                <div class="position-relative " style={{ width: "fit-content;" }}>
                                                                    <a target="_blank">
                                                                        <img src={`${process.env.REACT_APP_BASE_URL}/${notificationData?.imageUrl}`} class="img-thumbnail" />
                                                                    </a>
                                                                    <button type="button" class="btn btn-danger btn-sm position-absolute top-0 end-0" onClick={() => confirmDeleteDailog()}> &times; </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <small className="text-danger">{errors.imageUrl?.message}</small>
                                                    </div>
                                                ) : (
                                                    <div class="col-md-3">
                                                        <label class="form-label">Image Url</label>
                                                        <br />
                                                        <div>
                                                            <input type="file" accept=".jpeg, .jpg, .png, .webp" name="imageUrl" {...register("imageUrl")} class="form-control fileMultiInput" />
                                                        </div>
                                                        <small className="text-danger">{errors.imageUrl?.message}</small>
                                                        {previewImage?.[0] && (
                                                            <div class="mt-3 mb-2">
                                                                <div class="d-inline-block ">
                                                                    <div class="position-relative " style={{ width: "fit-content;" }}>
                                                                        <a target="_blank">
                                                                            <img src={URL.createObjectURL(previewImage[0])} id="existingImagePhoto" class="img-thumbnail" />
                                                                        </a>
                                                                        <button type="button" class="btn btn-danger btn-sm position-absolute top-0 end-0" onClick={() => resetField('imageUrl')}> &times; </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                        }
                                                    </div>
                                                )}
                                                <div class="col-md-3 mt-2">
                                                    <label class="form-label">Is Read?</label>
                                                    <div class="form-check form-switch mb-2">
                                                        <input class="form-check-input mt-2" name="isRead" type="checkbox" id="flexSwitchCheckDefault" {...register("isRead")} />
                                                        <small className="text-danger">{errors.isRead?.message}</small>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-4">
                                                <button type="submit" class="btn btn-primary me-3">Save</button>
                                                <button type="button" onClick={() => resetValue()} class="btn btn-secondary reset-btn">Reset</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default AddNotifications
